import classNames from "@calcom/ui/classNames";

export function Logo({
  small,
  icon,
  inline = true,
  className,
  src,
}: {
  small?: boolean;
  icon?: boolean;
  inline?: boolean;
  className?: string;
  src?: string;
}) {
  const alt = "Luniea Booking";

  return (
    <h3 className={classNames("logo", inline && "inline", className)}>
      <strong>
        {icon ? (
          <img
            className="mx-auto h-9 w-9 rounded-md object-cover"
            alt={alt}
            title={alt}
            src={src ? `${src}?type=icon` : "/favicon-32x32.png"}
          />
        ) : src ? (
          <img
            className={classNames(small ? "h-4 w-auto" : "h-5 w-auto")}
            alt={alt}
            title={alt}
            src={src}
          />
        ) : (
          <>
            <img
              className={classNames(
                small ? "h-4 w-auto" : "h-5 w-auto",
                "block dark:hidden"
              )}
              alt={alt}
              title={alt}
              src="/luniea/logo-black.png"
            />

            <img
              className={classNames(
                small ? "h-4 w-auto" : "h-5 w-auto",
                "hidden dark:block"
              )}
              alt={alt}
              title={alt}
              src="/luniea/logo-white.png"
            />
          </>
        )}
      </strong>
    </h3>
  );
}
